import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

const Login = () => {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [brand, setBrand] = useState(() => {
    try {
      const cached = localStorage.getItem("om_brand_cache");
      if (cached) return JSON.parse(cached);
    } catch (_) { /* noop */ }
    return { company_name: "", logo_base64: "" };
  });

  useEffect(() => {
    const name = (brand.company_name || "").trim();
    document.title = name || "ORDER.OS";
  }, [brand.company_name]);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => {
        const data = r.data || {};
        setBrand(data);
        try { localStorage.setItem("om_brand_cache", JSON.stringify(data)); } catch (_) { /* noop */ }
      })
      .catch(() => {});
  }, []);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      nav("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login gagal");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="flex items-center justify-center p-10">
        <div className="w-full max-w-sm">
          {(brand.logo_base64 || "").trim() ? (
            <div className="mb-6 flex items-center gap-3">
              <img src={brand.logo_base64} alt={brand.company_name || "Logo"} className="h-14 w-14 object-contain bg-white border border-[#E4E4E7] p-1" data-testid="login-brand-logo" />
              <div>
                <div className="font-heading text-2xl font-black tracking-tight">{(brand.company_name || "").trim() || "ORDER.OS"}</div>
                <div className="label-cap">Sistem Manajemen Order</div>
              </div>
            </div>
          ) : (
            <>
              <div className="font-heading text-4xl font-black tracking-tight mb-2">{(brand.company_name || "").trim() || "ORDER.OS"}</div>
              <div className="label-cap mb-10">Sistem Manajemen Order</div>
            </>
          )}

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="label-cap block mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="w-full px-3 py-2.5 border border-[#E4E4E7] focus:border-[#002FA7] outline-none text-sm bg-white"
              />
            </div>
            <div>
              <label className="label-cap block mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="w-full px-3 py-2.5 border border-[#E4E4E7] focus:border-[#002FA7] outline-none text-sm bg-white"
              />
            </div>
            {error && (
              <div className="text-xs text-[#DC2626] border border-[#DC2626]/20 bg-[#DC2626]/5 p-3" data-testid="login-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="login-submit-button"
              className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-bold uppercase tracking-wider py-3 transition-colors disabled:opacity-60"
            >
              {submitting ? "Memproses…" : "Masuk"}
            </button>
          </form>
        </div>
      </div>
      <div className="hidden lg:block bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1517816743773-6e0fd518b4a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJ5JTIwbWluaW1hbCUyMGFyY2hpdGVjdHVyZSUyMHdoaXRlJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODExMzI4MDV8MA&ixlib=rb-4.1.0&q=85)" }} />
    </div>
  );
};

export default Login;
